import { api } from './api';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAnsweringUnitConfigEi: build.query<GetAnsweringUnitConfigEiApiResponse, GetAnsweringUnitConfigEiApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/elevator-integration/answering-units/${queryArg.deviceId}`,
      }),
    }),
    getIntercomConfigEi: build.query<GetIntercomConfigEiApiResponse, GetIntercomConfigEiApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/elevator-integration/intercoms/${queryArg.deviceId}`,
      }),
    }),
    getIntercomIntegrationStatusesEi: build.query<
      GetIntercomIntegrationStatusesEiApiResponse,
      GetIntercomIntegrationStatusesEiApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'POST',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/elevator-integration/intercoms/integration-statuses`,
      }),
    }),
    getSiteBuildingTopologyEi: build.query<GetSiteBuildingTopologyEiApiResponse, GetSiteBuildingTopologyEiApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/elevator-integration/building-topology`,
      }),
    }),
    getSiteEi: build.query<GetSiteEiApiResponse, GetSiteEiApiArg>({
      query: (queryArg) => ({ url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/elevator-integration` }),
    }),
    getSiteFloorMappingEi: build.query<GetSiteFloorMappingEiApiResponse, GetSiteFloorMappingEiApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/elevator-integration/floor-mapping`,
      }),
    }),
    getUserEi: build.query<GetUserEiApiResponse, GetUserEiApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/elevator-integration/users/${queryArg.userId}`,
      }),
    }),
    getVisitorCallEnabledEi: build.mutation<GetVisitorCallEnabledEiApiResponse, GetVisitorCallEnabledEiApiArg>({
      query: (queryArg) => ({ body: queryArg.body, method: 'POST', url: `/devices/visitor-call-enabled` }),
    }),
    linkSiteWithElevatorProviderEi: build.mutation<
      LinkSiteWithElevatorProviderEiApiResponse,
      LinkSiteWithElevatorProviderEiApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.linkSiteRequestDto,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/elevator-integration/link`,
      }),
    }),
    linkSiteWithSchindlerEquipmentEi: build.mutation<
      LinkSiteWithSchindlerEquipmentEiApiResponse,
      LinkSiteWithSchindlerEquipmentEiApiArg
    >({
      query: (queryArg) => ({
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/elevator-integration/schindler/link/${queryArg.equipmentNumber}`,
      }),
    }),
    refreshSiteBuildingTopologyEi: build.mutation<
      RefreshSiteBuildingTopologyEiApiResponse,
      RefreshSiteBuildingTopologyEiApiArg
    >({
      query: (queryArg) => ({
        method: 'POST',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/elevator-integration/building-topology/refresh`,
      }),
    }),
    updateAnsweringUnitConfigEi: build.mutation<
      UpdateAnsweringUnitConfigEiApiResponse,
      UpdateAnsweringUnitConfigEiApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.answeringUnitConfigurationDto,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/elevator-integration/answering-units/${queryArg.deviceId}`,
      }),
    }),
    updateIntercomConfigEi: build.mutation<UpdateIntercomConfigEiApiResponse, UpdateIntercomConfigEiApiArg>({
      query: (queryArg) => ({
        body: queryArg.deviceRequestDto,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/elevator-integration/intercoms/${queryArg.deviceId}`,
      }),
    }),
    updateSiteEi: build.mutation<UpdateSiteEiApiResponse, UpdateSiteEiApiArg>({
      query: (queryArg) => ({
        body: queryArg.siteRequestDto,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/elevator-integration`,
      }),
    }),
    updateSiteFloorMappingEi: build.mutation<UpdateSiteFloorMappingEiApiResponse, UpdateSiteFloorMappingEiApiArg>({
      query: (queryArg) => ({
        body: queryArg.floorMappingDto,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/elevator-integration/floor-mapping`,
      }),
    }),
    updateUserEi: build.mutation<UpdateUserEiApiResponse, UpdateUserEiApiArg>({
      query: (queryArg) => ({
        body: queryArg.userRequestDto,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/elevator-integration/users/${queryArg.userId}`,
      }),
    }),
    visitorElevatorCallEi: build.mutation<VisitorElevatorCallEiApiResponse, VisitorElevatorCallEiApiArg>({
      query: (queryArg) => ({
        body: queryArg.elevatorCallRequestDto,
        method: 'POST',
        url: `/users/${queryArg.userId}/visitor-elevator-call`,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as elevatorIntegrationApi };
export type GetUserEiApiResponse = /** status 200 User elevator integration configuration */ UserDto;
export type GetUserEiApiArg = {
  companyId: string;
  siteId: string;
  userId: string;
};
export type UpdateUserEiApiResponse = /** status 204 User elevator configuration has been updated */ string;
export type UpdateUserEiApiArg = {
  companyId: string;
  siteId: string;
  userId: string;
  userRequestDto: UserRequestDto;
};
export type LinkSiteWithSchindlerEquipmentEiApiResponse =
  /** status 204 Site has been linked with Schindler equipment */ string;
export type LinkSiteWithSchindlerEquipmentEiApiArg = {
  companyId: string;
  siteId: string;
  equipmentNumber: string;
};
export type LinkSiteWithElevatorProviderEiApiResponse =
  /** status 204 Site has been linked with elevator provider */ string;
export type LinkSiteWithElevatorProviderEiApiArg = {
  companyId: string;
  siteId: string;
  linkSiteRequestDto: LinkSiteRequestDto;
};
export type GetIntercomConfigEiApiResponse = /** status 200 Device elevator integration configuration */ DeviceDto;
export type GetIntercomConfigEiApiArg = {
  companyId: string;
  siteId: string;
  deviceId: string;
};
export type UpdateIntercomConfigEiApiResponse = /** status 204 Configuration has been set up */ string;
export type UpdateIntercomConfigEiApiArg = {
  companyId: string;
  siteId: string;
  deviceId: string;
  deviceRequestDto: DeviceRequestDto;
};
export type GetSiteFloorMappingEiApiResponse = /** status 200 Site floor mapping */ FloorMappingDto;
export type GetSiteFloorMappingEiApiArg = {
  companyId: string;
  siteId: string;
};
export type UpdateSiteFloorMappingEiApiResponse = /** status 204 Site floor mapping has been updated */ string;
export type UpdateSiteFloorMappingEiApiArg = {
  companyId: string;
  siteId: string;
  floorMappingDto: FloorMappingDto;
};
export type GetAnsweringUnitConfigEiApiResponse =
  /** status 200 Answering unit apartment-call configuration */ AnsweringUnitConfigurationDto;
export type GetAnsweringUnitConfigEiApiArg = {
  companyId: string;
  siteId: string;
  deviceId: string;
};
export type UpdateAnsweringUnitConfigEiApiResponse = /** status 204 Configuration has been set up */ string;
export type UpdateAnsweringUnitConfigEiApiArg = {
  companyId: string;
  siteId: string;
  deviceId: string;
  answeringUnitConfigurationDto: AnsweringUnitConfigurationDto;
};
export type GetSiteEiApiResponse = /** status 200 Site elevator integration configuration */ SiteDto;
export type GetSiteEiApiArg = {
  companyId: string;
  siteId: string;
};
export type UpdateSiteEiApiResponse = /** status 204 Site elevator configuration has been updated */ string;
export type UpdateSiteEiApiArg = {
  companyId: string;
  siteId: string;
  siteRequestDto: SiteRequestDto;
};
export type VisitorElevatorCallEiApiResponse = /** status 200 Trigger landing/destination call for visitor */ string;
export type VisitorElevatorCallEiApiArg = {
  userId: string;
  elevatorCallRequestDto: ElevatorCallRequestDto;
};
export type GetVisitorCallEnabledEiApiResponse = /** status 200 Devices enabling visitor call */ string[];
export type GetVisitorCallEnabledEiApiArg = {
  body: string[];
};
export type GetIntercomIntegrationStatusesEiApiResponse =
  /** status 200 Device elevator integration statuses */ DeviceIntegrationStatusDto[];
export type GetIntercomIntegrationStatusesEiApiArg = {
  companyId: string;
  siteId: string;
  body: string[];
};
export type RefreshSiteBuildingTopologyEiApiResponse =
  /** status 200 Refreshed site building topology */ BuildingTopologyDto;
export type RefreshSiteBuildingTopologyEiApiArg = {
  companyId: string;
  siteId: string;
};
export type GetSiteBuildingTopologyEiApiResponse = /** status 200 Site building topology */ BuildingTopologyDto;
export type GetSiteBuildingTopologyEiApiArg = {
  companyId: string;
  siteId: string;
};
export type UserDto = {
  userId: string;
  landingCallEnabled: boolean;
  destinationCallEnabled: boolean;
};
export type UserRequestDto = {
  landingCallEnabled: boolean;
  destinationCallEnabled: boolean;
};
export type LinkSiteRequestDto = {
  buildingIds: string[];
  secret: string;
};
export type DeviceStopDto = {
  buildingId: string;
  elevatorGroupId: string;
  areaId: string;
  walkingTime: number;
};
export type DeviceDto = {
  stops: DeviceStopDto[];
  landingCallEnabled: boolean;
  destinationCallEnabled: boolean;
  integrationActive: boolean;
};
export type DeviceRequestDto = {
  stops: DeviceStopDto[];
  landingCallEnabled: boolean;
  destinationCallEnabled: boolean;
};
export type StopDto = {
  buildingId: string;
  elevatorGroupId: string;
  areaId: string;
};
export type SingleFloorMappingDto = {
  floorId: string;
  mappings: StopDto[];
};
export type FloorMappingDto = {
  floors: SingleFloorMappingDto[];
};
export type ApartmentCallDto = {
  active: boolean;
  name: string;
  stop: DeviceStopDto;
};
export type VisitorCallDto = {
  active: boolean;
  autoPerformAction: boolean;
  stop: StopDto;
};
export type AnsweringUnitConfigurationDto = {
  apartmentCall?: ApartmentCallDto | null;
  visitorCall?: VisitorCallDto | null;
};
export type SiteDto = {
  buildingIds: string[];
  elevatorIntegrationEnabled: boolean;
  landingCallEnabled: boolean;
  destinationCallEnabled: boolean;
  visitorCallEnabled: boolean;
  apartmentCallEnabled: boolean;
  elevatorProvider: 'KONE' | 'SCHINDLER';
};
export type SiteRequestDto = {
  elevatorIntegrationEnabled: boolean;
  landingCallEnabled: boolean;
  destinationCallEnabled: boolean;
  visitorCallEnabled: boolean;
  apartmentCallEnabled?: boolean | null;
};
export type ElevatorCallRequestDto = {
  deviceId: string;
  timestamp: string;
};
export type DeviceIntegrationStatusDto = {
  deviceId: string;
  integrationActive: boolean;
};
export type DestinationDto = {
  areaId: string;
  shortName: string;
};
export type ElevatorGroupDto = {
  id: string;
  name: string;
  destinations: DestinationDto[];
};
export type BuildingDto = {
  id: string;
  elevatorGroups: ElevatorGroupDto[];
};
export type BuildingTopologyDto = {
  buildings: BuildingDto[];
};
export const {
  useGetAnsweringUnitConfigEiQuery,
  useGetIntercomConfigEiQuery,
  useGetIntercomIntegrationStatusesEiQuery,
  useGetSiteBuildingTopologyEiQuery,
  useGetSiteEiQuery,
  useGetSiteFloorMappingEiQuery,
  useGetUserEiQuery,
  useGetVisitorCallEnabledEiMutation,
  useLinkSiteWithElevatorProviderEiMutation,
  useLinkSiteWithSchindlerEquipmentEiMutation,
  useRefreshSiteBuildingTopologyEiMutation,
  useUpdateAnsweringUnitConfigEiMutation,
  useUpdateIntercomConfigEiMutation,
  useUpdateSiteEiMutation,
  useUpdateSiteFloorMappingEiMutation,
  useUpdateUserEiMutation,
  useVisitorElevatorCallEiMutation,
} = injectedRtkApi;
